// extracted by mini-css-extract-plugin
export default {"root":"q13fkSrq","blinkCursor":"h1h8OGWC","done":"J2mf0uT_"};